export default __webpack_public_path__ + "static/media/twitter.76eb1b8b.svg";